import { fetchExperienceById } from 'actions/ExperienceActions'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useAppDispatch } from 'hooks/reduxHooks'
import ExperienceOfferPageContent from './ExperienceOfferPageContent'
import ExperienceOfferPageLoadingSkeleton from './ExperienceOfferPageLoadingSkeleton'
import Error404Page from 'components/Pages/Error404Page'
import Error500Page from 'components/Pages/Error500Page'
import { RouteComponentProps, withRouter } from 'react-router'
import RedirectWithStatus from 'components/Common/RedirectWithStatus/RedirectWithStatus'
import { getExperienceOfferPageURL } from 'lib/offer/offerPageURL'
import { VIRGIN_VELOCITY_PARTNERSHIP_CODE } from 'constants/partnerships'
import ExperienceOfferPageStateProvider from 'contexts/Experience/ExperienceOfferPage/experienceOfferPageStateProvider'
import useExperiencePageReducer from 'hooks/ExperiencePage/useExperiencePageReducer'
import AnalyticsPageContext, { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import ModalProvider from 'contexts/ModalProvider'

interface Props extends RouteComponentProps<{ slug: string, id: string}> {
  regionCode: string;
  experience?: App.ExperienceOffer;
  currency: string;
  error?: any;
  isVelocityEnabled: boolean;
}

function ExperienceOfferPage(props: Props) {
  const { experience, match, error, regionCode, isVelocityEnabled } = props
  const [state, stateDispatch] = useExperiencePageReducer(experience)

  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchExperienceById(match.params.id))
  }, [dispatch, match.params.id])

  if (error) {
    if (error.status === 404) {
      return <Error404Page />
    }

    return <Error500Page />
  }

  if (experience && (experience.slug !== match.params.slug)) {
    return <RedirectWithStatus code={301} to={`/${regionCode.toLowerCase()}${getExperienceOfferPageURL(experience)}`} />
  }

  return <AnalyticsPageContext.Provider value={AnalyticsPage.offerPage}>
    <div>
      {!experience && <ExperienceOfferPageLoadingSkeleton />}
      {experience && <ExperienceOfferPageStateProvider state={state} dispatch={stateDispatch}>
        <ModalProvider>
          <ExperienceOfferPageContent experience={experience} isVelocityEnabled={isVelocityEnabled} />
        </ModalProvider>
      </ExperienceOfferPageStateProvider>
      }
    </div>
  </AnalyticsPageContext.Provider>
}

function mapStateToProps(state: App.State, ownProps: Partial<Props>) {
  return {
    regionCode: state.geo.currentRegionCode,
    experience: state.experience.experiences[ownProps.match.params.id],
    error: state.experience.experienceErrors[ownProps.match.params.id],
    currency: state.geo.currentCurrency,
    isVelocityEnabled: state.geo.partnership?.code === VIRGIN_VELOCITY_PARTNERSHIP_CODE,
  }
}

export default withRouter(connect(mapStateToProps)(ExperienceOfferPage))
